import React, { useEffect, useState } from 'react'

import CalculationCard from './CalculationCard'
import { CalculationProps, RequiredParamsProps } from '../../types/MedicalCalculations'
import { useAuth } from '../../context/AuthContext'

const Bmi: React.FC<CalculationProps> = (props) => {
  const [data, setData] = useState(undefined)
  const [requiredParams, setRequiredParams] = useState<RequiredParamsProps>({})
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const { backendRequest } = useAuth()

  useEffect(() => {
    setIsLoading(true)
    const reqParamsObj = {
      height: props.formData.height,
      weight: props.formData.weight,
    }
    setRequiredParams(reqParamsObj)

    const allParamsPresent = Object.values(reqParamsObj).every((value) => {
      if (value === null || value === undefined || value === '') {
        return false
      }
      return true
    })

    const getData = async () => {
      if (allParamsPresent) {
        const response = await backendRequest({
          method: 'GET',
          endpoint: '/api/medical-calculations/bmi',
          requiresAuth: true,
          params: {
            weight: props.formData.weight,
            height: props.formData.height,
          },
        })
        return response
      } else {
        return undefined
      }
    }
    getData().then((response) => {
      if (response && response.status === 200) {
        setData(response.data)
      } else {
        setData(undefined)
      }
      setIsLoading(false)
    })
  }, [props.formData])

  return (
    <CalculationCard
      title='BMI'
      value={data}
      units='kg/m<sup>2</sup>'
      requiredParams={requiredParams}
      isLoading={isLoading}
      formData={props.formData}
      setFormData={props.setFormData}
    />
  )
}

export default Bmi
